// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"13":"bcb94b76","703":"32c96833","787":"fb771931"}[chunkId] + ".chunk.js";
};